import {
    APIResponse,
    AuthenticatedVehicleDto,
    DeclineForm,
    EnumUserRole,
    OrderDto,
    OrderPaymentDetailsDto,
    OrderPriceDetail,
    OrderPriceDetailDto,
    OrdersSortDirection,
    OrdersTableColumns,
    OrderStatus,
    OrderStatusDto,
    OrderSubStatus,
    OrderVehicleDto,
    OrderVehiclePaymentLinkDto,
    Pagination,
    PaymentDto,
    PaymentTypeDto,
    SortDirection,
    VehicleDocumentAvailabilityDto,
    VehicleDto,
    VehicleImageDto,
    VehicleShipmentMetadataDto,
} from "@/shared/api-contract/api-contract";
import { useI18n } from "@/shared/composables/use-i18n";
import format from "date-fns/format";
import { setup } from "vue-class-component";
import { isNil } from "lodash";
import { Model, Options, Prop, Vue } from "vue-property-decorator";
import { currentUserModel } from "@/shared/state/current-user.model";
import { appCompanyStatusDialogModel } from "@/shared/components/app-company-status-dialog/app-company-status-dialog.model";
import { eff } from "@/core/utils/effect-ts-abbr";
import "./table-item.scss";
import { appAxios } from "@/core/utils/appAxios";
import { watch, watchEffect } from "vue";
import PaymentPopup from "@/dashboard/my-orders/new-popup/payment-popup/payment-popup.vue";
import UploadCmrPopup from "@/dashboard/my-orders/new-popup/upload-cmr-popup/upload-cmr-popup.vue";
import ConfirmDatePopup from "@/dashboard/my-orders/new-popup/confirm-date-popup/confirm-date-popup.vue";
import Calendar from "primevue/calendar";
import ManualTransferPopup from "@/dashboard/my-orders/new-popup/manual-transfer-popup/manual-transfer-popup.vue";
import { getEnvValue } from "@/shared/models/environment";

export const DAY_IN_MILLS = 86400000;

const maxDate = new Date();
maxDate.setMonth(12);
maxDate.setFullYear(new Date().getFullYear() + 2);

const d1 = new Date(new Date().getFullYear(), 7, 30);
const d2 = new Date(new Date().getFullYear() + 1, 7, 30);
const d3 = new Date(new Date().getFullYear(), 7, 31);
const d4 = new Date(new Date().getFullYear() + 1, 7, 31);

@Options({
    components: {
        "payment-popup": PaymentPopup,
        "upload-cmr-popup": UploadCmrPopup,
        "confirm-date-popup": ConfirmDatePopup,
        "p-calendar": Calendar,
        "manual-transfer-popup": ManualTransferPopup,
    },
})
export class OrderVehicleItem extends Vue {
    @Model("_selectedOrders", { required: false })
    selectedOrders!: Array<OrderDto>;
    @Model("_selectedCars", { required: false })
    selectedCars!: Array<OrderVehicleDto>;
    @Prop({ required: true })
    order!: OrderDto;
    @Prop({ required: true })
    orderStatus!: OrderStatus;
    @Prop({ required: true })
    orderVehicle!: OrderVehicleDto;
    @Model("_isPaymentsTransactionsPopup", { required: true })
    isPaymentsTransactionsPopup!: boolean;
    @Model("_orderPaymentDto", { required: true })
    orderPaymentDto!: OrderPaymentDetailsDto;
    @Model("_orderId", { required: true })
    orderId!: number;
    @Prop({ required: true })
    sortOrder!: OrdersSortDirection;
    @Prop()
    fetchOrders!: () => void;
    showPayPopup = false;
    selectedDates: Date[] = [];
    showUploadCrmPopup = false;
    vehicleImageDtos: VehicleImageDto[] = [];
    documents: VehicleDocumentAvailabilityDto[] = [];
    @Prop({ required: true })
    payments!: OrderPaymentDetailsDto;
    isManualTransferSelected = false;

    closePaymentsTransactionsPopup() {
        this.isPaymentsTransactionsPopup = false;
    }
    orderStatusClass: Record<OrderStatus, string> = {
        [OrderStatus.to_approve]: "dashboard__table--approve",
        [OrderStatus.to_transport]: "dashboard__table--deliver",
        [OrderStatus.on_order]: "dashboard__table--progress",
        [OrderStatus.to_pay]: "dashboard__table--pay",
        [OrderStatus.processing_documents]: "dashboard__table--waiting",
        [OrderStatus.completed]: "dashboard__table--completed",
    };

    i18n = setup(useI18n);
    orderStatusEnum = OrderStatus;
    orderSubStatusEnum = OrderSubStatus;

    showApprove = false;
    showDecline = false;
    showPay = false;
    showManual = false;
    showDocuments = false;
    showUploadCmr = false;
    pfnrValue = "";
    pickupDate = null;
    maxDate = maxDate;
    disabledDates = [d1, d2, d3, d4];
    disabledDays = [0, 6];
    orderPriceDetailDto: OrderPriceDetailDto | null = null;
    isPopupOpen = false;
    selectAvailable!: boolean;
    showDatePicker = true;
    showConfirmPopup = false;
    downloadingImages = false;

    created() {
        this.selectAvailable = Boolean(this.$route.query.select_available);
    }
    async mounted() {
        this.selectAvailableCars();
        watchEffect(async () => {
            await this.fetchDocumentAvailability(this.orderVehicle.vehicle.id);
            await this.fetchShipmentMetadata();
        });
    }

    get formattedSelectedDate() {
        return new Date(this.selectedDates[0]);
        // if (this.selectedDates) {
        //     const day = this.selectedDates[0].getDate().toString().padStart(2, "0");
        //     const month = (this.selectedDates[0].getMonth() + 1)
        //         .toString()
        //         .padStart(2, "0");
        //     const year = this.selectedDates[0].getFullYear();
        //     return `${day}/${month}/${year}`;
        // }
        // return null;
    }
    get isOrderWithTBD() {
        // return this._isOrderWithTBD(this.order);
        return false;
    }
    openTransactionPopup() {
        this.isPaymentsTransactionsPopup = true;
    }
    get currentVehicleIdAsList() {
        const vehicleId = String(this.orderVehicle.id);
        return [vehicleId];
    }

    get isCheckboxToTransport() {
        return this.orderVehicle.status.id === 8 || this.orderVehicle.status.id === 9;
    }
    getTargetDate(manufacturedDate) {
        if (manufacturedDate) {
            const epochStart = new Date(0);
            return new Date(
                epochStart.getTime() + manufacturedDate * 24 * 60 * 60 * 1000,
            );
        }
    }

    getYearFromDate(manufacturedDate: number | null) {
        const targetDate = this.getTargetDate(manufacturedDate);
        if (manufacturedDate && targetDate) {
            return targetDate.getFullYear();
        }
    }

    async openPaymentsTransactionsPopup(id: number) {
        await this.fetchOrderPaymentDto(id);
        this.orderPaymentDto.payments.sort((a, b) => b.date - a.date);
        this.orderId = id;
        this.openTransactionPopup();
    }

    async fetchOrderPaymentDto(id: number) {
        if (this.orderStatus !== String("to_pay") && this.orderStatus !== "3") return;
        await appAxios.value
            .get<APIResponse<OrderPaymentDetailsDto>>(`/client/web/orders/${id}/payments`)
            .then((response) => {
                if (response.data.status.code === 200) {
                    this.orderPaymentDto = response.data.data;
                }
            });
    }

    closePopup(event) {
        const isCancelButton = event.target.closest(".cancel-button");
        const isDeclineButton = event.target.closest(".decline-button");
        const isXButton = event.target.closest(".x");

        if (isCancelButton || isDeclineButton || isXButton) {
            this.isPopupOpen = false;
        }
    }

    closeManualTransfer() {
        this.isManualTransferSelected = false;
    }

    selectAvailableCars() {
        const statusId = this.orderVehicle.status.id;
        if (this.selectAvailable && [5, 7, 9, 10, 13, 14].includes(statusId)) {
            this.selectedCars.push(this.orderVehicle);
        }
    }

    showCompanyStatusDialog(
        type: "default" | "order-approve" | "order-decline" = "default",
    ): boolean {
        return appCompanyStatusDialogModel.show(type);
    }

    isOrderInStatus(_status: OrderStatus) {
        return this.order?.status.id.toString() === _status;
    }

    isOrderInSubStatus(_subStatus: OrderSubStatus) {
        // return this.order?.subStatus === _subStatus;
        return false;
    }

    handleDateSelected(value) {
        this.selectedDates = value;
        this.showDatePicker = false;
        this.showConfirmPopup = true;
    }
    getDatePicker() {
        this.showDatePicker = true;
        if (this.$refs.fileInput instanceof HTMLElement) {
            this.$refs.fileInput.click();
        }
    }
    formatDate(_date?: number): string {
        if (!_date) return "DD/MM/YYYY";
        const millisecondsSinceEpoch = Number(_date) * 24 * 60 * 60 * 1000;
        const date = new Date(millisecondsSinceEpoch);
        return format(new Date(Number(date)), "dd/MM/yyyy");
    }

    formatTime(_date?: number): string {
        if (!_date) return "HH:MM";
        return format(new Date(_date), "HH:MM");
    }
    selectCar(e) {
        const exists = this.selectedCars.some(
            (data) => data?.id === this.orderVehicle.id,
        );
        if (e.target?.checked && !exists) {
            this.selectedCars = [...this.selectedCars, this.orderVehicle];
        } else {
            this.selectedCars = this.selectedCars.filter(
                (data) => data?.id !== this.orderVehicle.id,
            );
        }
    }

    get isSelected() {
        return eff.fn.pipe(
            this.selectedCars,
            eff.array.findFirst((_car) => _car?.id === this.orderVehicle.id),
            eff.option.isSome,
        );
    }

    get isProcessingPayment() {
        const paymentSubStatusId = this.orderVehicle.status.id;
        return paymentSubStatusId === 6 || paymentSubStatusId === 8;
    }
    get isAwaitingPayment() {
        const paymentSubStatusId = this.orderVehicle.status.id;
        return paymentSubStatusId === 6 || paymentSubStatusId === 8;
    }

    get isSelectionAllowed() {
        const statusId = this.orderVehicle.status.id;
        return [5, 7, 9, 13, 14].includes(statusId);
    }

    async fetchDocumentAvailability(vehicleId: number) {
        await appAxios.value
            .get<APIResponse<VehicleDocumentAvailabilityDto[]>>(
                `/client/web/orders/${this.order.id}/vehicles/${vehicleId}/shipment/documents`,
            )
            .then((response) => {
                this.documents = response.data.data;
            })
            .catch(console.log);
    }
    fetchAssociatedWithOrderVehicles(paymentId: number): OrderVehiclePaymentLinkDto[] {
        appAxios.value
            .get<APIResponse<OrderVehiclePaymentLinkDto[]>>(
                `/client/web/orders/${this.order.id}/payments/${paymentId}/vehicles`,
            )
            .then((response) => {
                const vehicles: OrderVehiclePaymentLinkDto[] = response.data.data;
                return vehicles;
            })
            .catch(console.log);
        return [];
    }

    get isManualPayment() {
        return false;
    }

    get isMolliePayment() {
        return true;
    }

    async downloadZipByImageId(): Promise<void> {
        this.downloadingImages = true;
        try {
            const response = await appAxios.value.get(
                `/client/web/vehicles/${this.orderVehicle.vehicle.id}/images/zip`,
                {
                    responseType: "blob",
                },
            );
            const blob = new Blob([response.data], { type: "application/zip" });

            const fileName = `${this.orderVehicle.vehicle.id}.zip`;
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
        } catch (error) {
            console.error(error);
            // alert("Failed to download ZIP file.");
        } finally {
            this.downloadingImages = false;
        }
    }
    async fetchAvailablePaymentTypes() {
        await appAxios.value
            .get<APIResponse<PaymentTypeDto[]>>(
                `/client/web/enumerator/order/payment/type`,
            )
            .then((response) => {
                // TODO use this response data
            });
    }
    get showPayment() {
        const paymentSubStatusId = this.orderVehicle.status.id;
        return paymentSubStatusId === 7;
    }
    get isRegAvailable() {
        return this.documents.some(
            (document) => document?.documenttype?.id === 2 && document?.available,
        );
    }
    get isCocAvailable() {
        return this.documents.some(
            (document) => document?.documenttype?.id === 1 && document?.available,
        );
    }

    async fetchShipmentMetadata() {
        await appAxios.value
            .get<APIResponse<VehicleShipmentMetadataDto>>(
                `/client/web/orders/${this.order.id}/vehicles/${this.orderVehicle.vehicle.id}/shipment/vehicle`,
            )
            .then((response) => {
                // TODO use this response data
            });
    }
    async fetchVehicleImageDtos(vehicleId: number) {
        await appAxios.value
            .get<APIResponse<VehicleImageDto[]>>(
                `/client/web/vehicles/${vehicleId}/images`,
            )
            .then((response) => {
                this.vehicleImageDtos = response.data.data;
            });
    }

    get brandLabel() {
        return getEnvValue("BRAND_LABEL");
    }

    get isAstara() {
        return this.brandLabel === "astara";
    }

    closeConfirmPopup(params) {
        const { isSuccess } = params ?? {};
        this.showConfirmPopup = false;
        if (this.fetchOrders && isSuccess) {
            this.fetchOrders();
        }
    }
}
